import { authFetch } from '@/lib/api-client';
import type {
  BootstrapCompetitorFilterDefaultsPayload,
  CompetitorFilterDefaultsData,
  ExploreApiPrefix,
} from '../lib/competitor-filter-defaults';

export async function fetchCompetitorFilterDefaults(
  exploreBasePath: ExploreApiPrefix,
  options?: { signal?: AbortSignal },
): Promise<CompetitorFilterDefaultsData> {
  const { data } = await authFetch<CompetitorFilterDefaultsData>(
    `${exploreBasePath}/competitor-filter-defaults`,
    { signal: options?.signal },
  );
  return data;
}

export async function bootstrapCompetitorFilterDefaults(
  exploreBasePath: ExploreApiPrefix,
  payload: BootstrapCompetitorFilterDefaultsPayload,
): Promise<{ wrote: boolean }> {
  const { data } = await authFetch<{ wrote: boolean }>(
    `${exploreBasePath}/competitor-filter-defaults`,
    { method: 'PUT', body: JSON.stringify(payload) },
  );
  return data;
}
